import { combineReducers } from "redux";
import RouteMenuReducer from 'HELPDESK/Reducers/RouteMenuReducer';

const Reducers = combineReducers({
    RouteMenuReducer
});

export default Reducers;